import * as React from 'react'
import { useCustomer } from 'services/queries/use-customer'
import { useParams } from 'react-router'
import { Stack, TextField, Box, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Rights from './widgets/rights'
import UsageAndLimits from './usage-table'
import RestoreDefaultsDialog from './widgets/restore-default-dialog'
import CountrySpecific from './widgets/country-specific'
import { countriesForCountrySpecific } from './restrictions.model'
import { CountrySpecificTypes } from 'services/cm-api/get-customer'

const Restrictions = ({ usersLength }: { usersLength: number }) => {
  const { id: selectedCustomer } = useParams()
  const [search, setSearch] = React.useState('')

  const useCustomerQuery = useCustomer(selectedCustomer!)
  const data = useCustomerQuery.data
  // Return only the country specific data
  const handleDataCountrySpecific = (): CountrySpecificTypes => {
    let localData = {}
    countriesForCountrySpecific.forEach(({ countryCode }) => {
      localData = {
        ...localData,
        [countryCode]: data?.rights[countryCode as keyof typeof data.rights],
      }
    })
    return localData as CountrySpecificTypes
  }

  return data ? (
    <Stack spacing={3} sx={{ width: '100%', pt: 2, pb: 3 }}>
      {/* Search and Actions Bar */}
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        sx={{ width: '100%' }}
      >
        <TextField
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search restrictions..."
          variant="outlined"
          sx={{ flex: 1, maxWidth: 400 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ width: 160 }}>
          <RestoreDefaultsDialog />
        </Box>
      </Stack>

      {/* Rights Section */}
      <Rights search={search} data={data.rights} />

      {/* Usage & limits (ENG2-2461) */}
      <UsageAndLimits data={data} usersLength={usersLength} search={search} />

      {/* Country Specific Section */}
      <CountrySpecific search={search} data={handleDataCountrySpecific()} />
    </Stack>
  ) : null
}

export default Restrictions
